export const combineFullUrl = (url: string, queryParams: URLSearchParams | undefined) =>
    url + '?' + (queryParams?.toString() ?? '');
